import { render, staticRenderFns } from "./Newgamesbox.vue?vue&type=template&id=b6ff0712&scoped=true&"
import script from "./Newgamesbox.vue?vue&type=script&lang=js&"
export * from "./Newgamesbox.vue?vue&type=script&lang=js&"
import style0 from "./Newgamesbox.vue?vue&type=style&index=0&id=b6ff0712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ff0712",
  null
  
)

export default component.exports